// extracted by mini-css-extract-plugin
export default {"wrapper":"SubsExpiredBanner_wrapper__aM3Id"};